module.exports = __webpack_public_path__ + "static/media/Portuguese_ Brazilian_Marcos BG-05.5717dbe2.png";